import { Avatar, Typography } from '@mui/material';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { stringAvatar } from '../../../utils/common.util';
import { getRelativeDateFromNow } from '../../../utils/date.util';
import messages from '../messages';
import NotificationIgnoreButton from './NotificationIgnoreButton';
import TeamMemberLink from '../../common/TeamMemberLink';
import { FlexTextContainer } from '../../common/ui/Container';

function AgeUnder12({
  member,
  createdAt,
  updatedAt,
  status,
  disableIgnore,
  onIgnore,
  canIgnore,
}) {
  const { displayName, avatarUrl, team, id } = member;
  const eventId = team?.event?.id;
  const eventGroupId = team?.event?.eventGroupId;
  const teamAvatar = stringAvatar(displayName);
  const relativeDateInSecond = getRelativeDateFromNow(updatedAt || createdAt);
  return (
    <FlexTextContainer sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Avatar sx={teamAvatar.sx} src={avatarUrl}>
        {teamAvatar.children}
      </Avatar>
      <Typography variant="subtitle">
        <FormattedMessage
          id={messages.under12.id}
          defaultMessage={messages.under12.defaultMessage}
          values={{
            // eslint-disable-next-line react/no-unstable-nested-components
            member: () => (
              <Typography component="span">
                <TeamMemberLink
                  displayName={displayName}
                  id={id}
                  eventId={eventId}
                  eventGroupId={eventGroupId}
                ></TeamMemberLink>
              </Typography>
            ),
            name: displayName,
          }}
        />
      </Typography>
      <Typography variant="caption">{relativeDateInSecond}</Typography>
      {status === 'active' && canIgnore && (
        <NotificationIgnoreButton
          onClickHandler={onIgnore}
          loading={disableIgnore}
        ></NotificationIgnoreButton>
      )}
    </FlexTextContainer>
  );
}

export default memo(AgeUnder12);
